export default "__VITE_ASSET__CfaUnPkp__"